

import React from 'react';
import ServiceForm from '../components/ServiceForm';


const serviceEndpoint = "season/%sid/match/%nid/delete-event/%eid";
const serviceArguments = []

const serviceUrlArguments = [
  { name: 'sid', type: 'numeric',  mandatory: true, default: '', description: 'Season ID'},
  { name: 'nid', type: 'numeric',  mandatory: true, default: '', description: 'Match ID'},
  { name: 'eid', type: 'numeric',  mandatory: true, default: '', description: 'Event ID'},
]

const serviceSample = {}


export function MatchEventDelete() {
  return <MatchEventDeleteComponent/>;
}


class MatchEventDeleteComponent extends React.Component {

  render() {

        return (
            <div>
                  <h3>Delete a Match Event</h3>

                  <p>Endpoint: <b>{serviceEndpoint}</b></p>

                  <p>
                    This service can be used to delete a Match Event.<br/>
                    <br/>
                  </p>
                  
                  <ServiceForm
                        args={serviceArguments}
                        urlArgs={serviceUrlArguments}
                        sample={serviceSample}
                        endpoint={serviceEndpoint}
                        authRequired={true}
                        usePayload={false}
                  />

                  <h4>Request</h4>
                  <p>
                  Simple GET or POST request without parameters
                  </p>
                  
                  <h4>Response</h4>
                  <p>
                    A JSON with the the object 'result' =&gt; 'ok'
                  </p>
                  
            </div>
        );
  }


} 